import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

const ChatPreviewSkeleton = () => {
  return (
    <div className="relative flex w-full flex-row items-start justify-start gap-3.5 px-6 py-2.5">
      <div className="flex">
        <Skeleton animationType="shimmer" className="size-[55px] rounded-full" />
      </div>
      <div className="flex flex-1 flex-col items-start justify-start gap-1">
        <div className="flex w-full items-center justify-between gap-2">
          <Skeleton animationType="shimmer" className="h-4 w-[45%] max-w-[200px]" />
          <div className="flex max-w-[50px] flex-row items-center justify-center gap-1">
            <Skeleton animationType="shimmer" className="h-3 w-8 rounded" />
            <Skeleton animationType="shimmer" className="size-3 rounded-full" />
          </div>
        </div>
        <div className="flex w-full items-start justify-start gap-1.5">
          <Skeleton animationType="shimmer" className="mt-0.5 size-4 rounded-full" />
          <div className="mt-1 flex w-full flex-col gap-1">
            <Skeleton animationType="shimmer" className="h-2.5 w-full max-w-[280px]" />
            <Skeleton animationType="shimmer" className="h-2.5 w-[65%] max-w-[220px]" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatPreviewSkeleton
